import { useAtom } from '@reatom/npm-react'
import { motion } from 'motion/react'
import styled, { css } from 'styled-components'

import { tradeOrderTypeAtom } from '@root/features/trade/trading'

import { TradingControlsSellButton } from '../../common/trading-controls-sell/trading-controls-sell-button'
import { TradingControlsLimitSell } from '../../common/trading-controls-sell/trading-controls-sell-limit'
import { TradingControlsWallet } from '../trading-controls-wallet'

import { TradingControlsAmountSell } from './trading-controls-sell-amount'

import type { SellControlsModel } from '../../../atoms/common'
import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
  model: SellControlsModel
}

export const TradingControlsSellForm: React.FC<Props> = ({ pair, model }) => {
  const [tradeOrderType] = useAtom(tradeOrderTypeAtom)

  return (
    <Root>
      <TradingControlsAmountSell model={model.inputModel} pair={pair} />
      {tradeOrderType === 'limit' ? (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <TradingControlsLimitSell model={model.limitModel} pair={pair} />
        </motion.div>
      ) : undefined}
      <Bottom>
        <TradingControlsWallet pair={pair} />
        <TradingControlsSellButton
          model={model}
          css={css`
            grid-column: button;
          `}
          pair={pair}
        />
      </Bottom>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 10px;
`

const Bottom = styled.div`
  display: grid;
  grid-template-columns: [wallet] auto [button] minmax(0, 1fr);
  align-items: center;
  padding-inline: 10px;
  gap: 6px;
`
